module.exports = __webpack_public_path__ + "static/etc-e9b33f2a76b017613d97456a5c275b33.jpg";